import { useContext, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { ImageLibraryModalContext } from 'features/image/ImageLibraryModalContext'
import ImageUploadGuidelines from 'features/image/ImageUploadGuidelines'
import Tooltip from 'components/tooltip/Tooltip'
import PropTypes from 'prop-types'
import { ImageSizes } from 'features/image/ImageSizes'
import { showImageLibraryModal } from 'features/image/imageLibrarySlice'
import { nanoid } from '@reduxjs/toolkit'
import classNames from 'classnames'
import NoneAnchor from 'components/NoneAnchor'
import { byteToKb } from 'utils'
import { GitbookLinks } from '../../../../utils/constants'

const IMAGE_EXTENSION = {
  JPG: 'JPG',
  JPEG: 'JPEG',
  PNG: 'PNG',
}

const getImageExtension = name => {
  if (name) {
    if (name.toUpperCase().endsWith(IMAGE_EXTENSION.JPEG)) {
      return IMAGE_EXTENSION.JPEG
    } else if (name.toUpperCase().endsWith(IMAGE_EXTENSION.PNG)) {
      return IMAGE_EXTENSION.PNG
    } else {
      return IMAGE_EXTENSION.JPG
    }
  } else {
    return 'JPG,JPEG,PNG'
  }
}

const ImageLibraryUpload = ({
  maxCount,
  requiredImageSize,
  handleImageUpload,
  disabled,
  onClickDelete,
  imageUrl,
  imageName,
  imageSize,
  guideLink = GitbookLinks.PREMIUM_LINK_REGISTRATION,
}) => {
  const dispatch = useDispatch()
  const idRef = useRef(nanoid())
  const { afterConfirmRef } = useContext(ImageLibraryModalContext)
  const extension = getImageExtension(imageName)
  const handleClick = e => {
    e.preventDefault()
    afterConfirmRef.current = handleImageUpload
    dispatch(
      showImageLibraryModal({
        maxCount,
        allowImageSizes: requiredImageSize,
      })
    )
  }
  return imageUrl ? (
    <div className="regist_img load_ok">
      <div className="item_file">
        <div className="file_info">
          <span className="img_file">
            <img src={imageUrl} alt="소재 이미지" className="img_thumb" />
            <span className="frame_g" />
          </span>
          <span className="txt_file">
            <span className="txt_upload">{imageName}</span>
            <span className="txt_byte">
              {`${requiredImageSize[0].width} x ${requiredImageSize[0].height}`}
              <span className="txt_bar">|</span>
              {extension}
              <span className="txt_bar">|</span>
              {byteToKb(imageSize) || 400}KB
            </span>
          </span>
          <button
            type="button"
            className="btn_del"
            onClick={onClickDelete}
            disabled={disabled}>
            <span className="ico_comm ico_del">삭제</span>
          </button>
        </div>
      </div>
    </div>
  ) : (
    <>
      <div className="regist_btn">
        <span className={classNames('btn_gw', { in_active: disabled })}>
          <label htmlFor={idRef.current} className="lab_file">
            <span className="inner_g">
              <span className="img_comm ico_add" />
              이미지 추가
            </span>
          </label>
          <input
            type="file"
            id={idRef.current}
            className="inp_file"
            onClick={handleClick}
            disabled={disabled}
          />
        </span>
      </div>
      <div className="guide_file">
        <em className="screen_out">업로드 가이드</em>
        <ul className="list_fileguide">
          <li>
            <Tooltip
              position="bottom"
              content={
                <ImageUploadGuidelines allowImageSizes={requiredImageSize} />
              }>
              <NoneAnchor className="link_guide">소재 등록 가이드</NoneAnchor>
            </Tooltip>
          </li>
          <li>
            <a
              href={guideLink}
              target="_blank"
              rel="noopener noreferrer"
              className="link_guide">
              심사 가이드
              <span className="ico_comm ico_guide" />
            </a>
          </li>
        </ul>
      </div>
    </>
  )
}

ImageLibraryUpload.propTypes = {
  requiredImageSize: PropTypes.arrayOf(
    PropTypes.oneOf(Object.values(ImageSizes))
  ),
  maxCount: PropTypes.number,
  handleImageUpload: PropTypes.func,
  onClickDelete: PropTypes.func,
  disabled: PropTypes.bool,
  imageName: PropTypes.string,
  imageUrl: PropTypes.string,
  imageSize: PropTypes.number,
  guideLink: PropTypes.string,
}
export default ImageLibraryUpload
